'use client'

import { createContext } from 'react'

import type { PublicUser } from '@miimosa/common/types'

const UserContext = createContext<PublicUser | undefined>(undefined)

export default UserContext
